import { Address, Chain } from "viem";

import { galacticaAndromeda } from "./networks/galactica-andromeda";
import { galacticaCassiopeia } from "./networks/galactica-cassiopeia";
import { galacticaReticulumTestnet } from "./networks/galactica-reticulum";

export const supportedChains = [
  galacticaAndromeda,
  galacticaReticulumTestnet,
  galacticaCassiopeia,
].filter(
  (chain) => chain.id === Number.parseInt(import.meta.env.VITE_CHAIN_ID)
) as [Chain, ...Chain[]];

console.log(window.location.host);

export const links = {
  [galacticaAndromeda.id]: {
    sampleKYCProvider: "https://kyc-andromeda.galactica.com",
    swissborgKYCProvider: "https://stage-swissborg.galactica.com",
    occamDataGuardian: "https://stage-guardian.occam.fi",
  },
  [galacticaReticulumTestnet.id]: {
    sampleKYCProvider: "https://kyc-reticulum.galactica.com",
    swissborgKYCProvider: "https://swissborg.galactica.com",
    occamDataGuardian: "https://guardian-reticulum.occam.fi",
  },
  [galacticaCassiopeia.id]: {
    // TODO: cassiopeia
    sampleKYCProvider: "https://kyc-cassiopeia.galactica.com",
    swissborgKYCProvider: "https://swissborg.galactica.com",
    occamDataGuardian: "https://guardian.occam.fi",
  },
};

export const featuresFlags = {
  [galacticaAndromeda.id.toString()]: {
    soulMatrix: true,
    proofs: true,
    opportunities: true,
    staking: true,
    dataGuardians: true,
    canonicalBridge: false,
  },
  [galacticaReticulumTestnet.id.toString()]: {
    soulMatrix: true,
    proofs: true,
    opportunities: false,
    staking: false,
    dataGuardians: true,
    canonicalBridge: false,
  },
  [galacticaCassiopeia.id.toString()]: {
    soulMatrix: false,
    proofs: true,
    opportunities: false,
    staking: false,
    dataGuardians: false,
    canonicalBridge: true,
  },
} as const;

export const galacticaStakeContractConfig: Record<number, Address> = {
  [galacticaAndromeda.id]:
    "0x0000000000000000000000000000000000000064" as Address,
};
